import { throwForFailedResponse } from "@/lib/errors/error-handler";

async function getJson<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.success === false) {
    throwForFailedResponse(res, data, "Request failed");
  }
  return (data?.data ?? data) as T;
}


export interface BlogListParams {
  search?: string;
  category?: string;
}

export const blogService = {
  async getAll(params?: BlogListParams) {
    const qs = new URLSearchParams();
    if (params?.search) qs.set("search", params.search);
    if (params?.category) qs.set("category", params.category);
    const query = qs.toString() ? `?${qs}` : "";
    return getJson(`/api/blog${query}`);
  },

  async getCategories(): Promise<string[]> {
    return getJson(`/api/blog/categories`);
  },

  async getBySlug(slug: string) {
    return getJson(`/api/blog/slug?slug=${encodeURIComponent(slug)}`);
  },
};